import Header from "../component/Header";
import { Box, Typography } from "@mui/material";
import MyBottomNavigation from "../component/MyBottomNavigation";
import { useTranslation } from "react-i18next";

function Page404(): JSX.Element {
  const { t } = useTranslation();
  
  return (
    <>
      <Header/>
      <Box 
        sx={{ p: 3 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Typography component="div" variant="caption">
          {t("pages.page404.notFound")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("pages.page404.instruction")}
        </Typography>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        width="100%"
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <MyBottomNavigation />
      </Box>
    </>
  );
};
export default Page404;
